"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.webScrapingExample = exports.indexCode = exports.blankExample = exports.scrapeExample = exports.pdfExample = exports.screenshotExample = exports.searchExample = void 0;
exports.searchExample = `// Full TypeScript support for both puppeteer and the DOM
export default async ({ page }: { page: Page }) => {

  // Full puppeteer API is available
  await page.goto('https://botd-widget.fpjs.sh/');
};`;
exports.screenshotExample = `// Let's load up a cool dashboard and screenshot it!
export default async ({ page }: { page: Page }) => {
  await page.goto('https://play.grafana.org/d/000000029/prometheus-demo-dashboard?orgId=1&refresh=5m&kiosk', { waitUntil: 'networkidle0'});

  // Enlarge the viewport so we can capture it.
  await page.setViewport({ width: 1920, height: 1080 });

  // Return the screenshot buffer which will trigger this editor to download it.
  return page.screenshot({ fullPage: true });
};`;
exports.pdfExample = `// For PDFs, let's take some API content and inject some simple styles
export default async ({ page }: { page: Page }) => {

  // Let's get React's documentation and scrape out
  // their actual API docs without all the other stuff.
  await page.goto('https://reactjs.org/docs/react-api.html');
  const apiContent = await page.evaluate(() => document.querySelector('article').innerHTML);

  // Now, let's get some simple markdown CSS for print
  await page.goto('https://raw.githubusercontent.com/simonlc/Markdown-CSS/master/markdown.css');
  const stylesheet = await page.evaluate(() => document.body.innerText);

  // Finally, let's inject the above in a blank page and print it.
  await page.goto('about:blank');
  await page.setContent(apiContent);
  await page.addStyleTag({ content: stylesheet });
  
  // Return a PDF buffer to trigger the editor to download.
  return page.pdf();
};`;
exports.scrapeExample = `// In this example, we'll scrape links on HN
export default async ({ page }: { page: Page }) => {
  await page.goto('https://news.ycombinator.com');

  // Here, we inject some JavaScript into the page to build a list of results
  const items = await page.evaluate(() => {
    const elements = [...document.querySelectorAll('.athing a')];
    const results = elements.map((el: HTMLAnchorElement) => ({
      title: el.textContent,
      href: el.href,
    }));
    return JSON.stringify(results);
  });

  // Finally, we return an object, which triggers a JSON file download
  return JSON.parse(items);
};`;
exports.blankExample = `export default async ({ page }: { page: Page }) => {
  // Do Something with the page and return!
  // The editor will detect the return value, and either download
  // a JSON/PDF/PNG or Plain-text file. If you don't return
  // anything then nothing will happen.
};`;
exports.indexCode = `const { default: start } = require('./start.js');
const puppeteer = require('puppeteer-core');

(async () => {
  const browser = await puppeteer.connect({
    browserWSEndpoint: 'wss://chrome.browserless.io'
  });
  const page = await browser.newPage();

  await start({ page, browser });

  return browser.close();
})()
.then(() => console.log('Script complete!'))
.catch((err) => console.error('Error running script' + err));`;
exports.webScrapingExample = `// This bot cannot scrape flight data from demo.fingerprint.com because they are 
// protected by Fingerprint Pro Bot Detection. 
// * Press "Play" to see it in action.
// * A "Malicious bot detected, access denied" error will appear on the website
//   below the Search button instead of the flight search results.
// * "Scraping flights failed" will appear in the DevTools Console.
export default async ({ page }: { page: Page }) => {

  // Flip the \`disableBotDetection\` boolean below to disable Fingerprint Pro Bot Detection
  // and see how the scraping bot works normally. 
  // * Press "Play" again to test.
  // * Flight results will appear on the website below the Search button.
  // * The scraped flight data will be logged in the DevTools Console and downloaded as a JSON file. 
  const disableBotDetection = false;
  await page.goto(
    \`https://demo.fingerprint.com/web-scraping\${disableBotDetection ? '?disableBotDetection=1' : ""}\`,
    { waitUntil: 'networkidle0'}
  );

  const flights = await page.evaluate(() => {
    const cards = [...document.querySelectorAll('[data-test="card"]')];
    return cards.map((el) => ({
      origin: el.querySelector("[data-test='originAirportCode']").textContent,
      destination: el.querySelector("[data-test='destinationAirportCode']").textContent,
      price: el.querySelector("[data-test='price']").textContent
    }));
  });
  

  if (flights.length > 0) {
    console.log(JSON.stringify(flights));
    return flights;
  } else {
    console.log("Scraping flights failed");
  }
};
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGFBQWEsR0FBRzs7Ozs7R0FLMUIsQ0FBQztBQUVTLFFBQUEsaUJBQWlCLEdBQUc7Ozs7Ozs7OztHQVM5QixDQUFDO0FBRVMsUUFBQSxVQUFVLEdBQUc7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7R0FtQnZCLENBQUM7QUFFUyxRQUFBLGFBQWEsR0FBRzs7Ozs7Ozs7Ozs7Ozs7OztHQWdCMUIsQ0FBQztBQUVTLFFBQUEsWUFBWSxHQUFHOzs7OztHQUt6QixDQUFDO0FBRVMsUUFBQSxTQUFTLEdBQUc7Ozs7Ozs7Ozs7Ozs7OzhEQWNxQyxDQUFDO0FBR2xELFFBQUEsa0JBQWtCLEdBRS9COzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FvQ0MsQ0FBQyJ9